var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-box"},[_c('div',{staticClass:"list"},_vm._l((_vm.routeLinks),function(item){return _c('RouterLink',{key:item.title,staticClass:"item-link",attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }